var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatNavigationS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1C3.2 1 0 3.2 0 8C0 9.6 0.251 10.318 0.696 11.252L0 15L3.346 14.044C3.346 14.044 4.922 15 8 15C12.8 15 16 12.8 16 8C16 3.2 12.8 1 8 1ZM8 13.5C5.455 13.5 4.124 12.762 4.124 12.762L3.564 12.422L1.917 12.893L2.26 11.047L2.05 10.607C1.709 9.891 1.5 9.383 1.5 8C1.5 4.35 3.687 2.5 8 2.5C12.313 2.5 14.5 4.35 14.5 8C14.5 11.65 12.313 13.5 8 13.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.88512 4.30005C7.30538 4.30005 6.74939 4.53035 6.33945 4.94028C5.92952 5.35022 5.69922 5.90621 5.69922 6.48595H6.89153C6.89153 6.22243 6.99621 5.9697 7.18254 5.78337C7.36887 5.59704 7.6216 5.49236 7.88512 5.49236H8.52897C8.72638 5.49235 8.91576 5.57047 9.05576 5.70963C9.19549 5.84854 9.27469 6.03701 9.27614 6.23402C9.27623 6.34556 9.25133 6.45571 9.20328 6.5564C9.15514 6.65725 9.08457 6.74636 8.99761 6.81651L7.28896 8.18708V9.66543H8.48127V8.75917L9.74544 7.74513C9.97173 7.5629 10.1542 7.33216 10.2793 7.06996C10.4044 6.80777 10.4691 6.52081 10.4685 6.23026L10.4684 6.22806C10.4654 5.71567 10.2597 5.2253 9.89634 4.86405C9.53294 4.5028 9.04134 4.30004 8.52895 4.30005H7.88512Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.88512 12.05C8.32411 12.05 8.67999 11.6942 8.67999 11.2552C8.67999 10.8162 8.32411 10.4603 7.88512 10.4603C7.44612 10.4603 7.09024 10.8162 7.09024 11.2552C7.09024 11.6942 7.44612 12.05 7.88512 12.05Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatNavigationS);
export default __webpack_public_path__ + "static/media/chat-navigation-S.53f0601c85416391a81220b6b8e53e69.svg";
export { ForwardRef as ReactComponent };